import { render, staticRenderFns } from "./ProdutoMaisComprado.vue?vue&type=template&id=2bffc789"
import script from "./ProdutoMaisComprado.vue?vue&type=script&lang=js"
export * from "./ProdutoMaisComprado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports